import axios from "axios";
import { apiUrl } from "../../Apis/config";

export const getAllChairmanMeetingRequests = async ({
  userUid = null,
  startDate = "",
  endDate = "",
  meetingStatus = "",
} = {}) => {
  const body = {};
  if (userUid) body.userUid = userUid;
  if (startDate) body.startDate = startDate;
  if (endDate) body.endDate = endDate;
  if (meetingStatus) body.meetingStatus = meetingStatus;

  const response = await axios.post(
    `${apiUrl}/get-chairman-meeting-requests`,
    body
  );
  return response.data;
};

export const getChairmanMeetingRequestById = async (meetingRequestId) => {
  const response = await axios.post(
    `${apiUrl}/get-chairman-meeting-request-by-id`,
    { meetingRequestId }
  );
  return response.data;
};

export const acceptChairmanMeetingRequest = async ({
  meetingRequestId,
  approvedByUid,
  expectedMeetingDate,
  location,
}) => {
  const response = await axios.post(
    `${apiUrl}/accept-chairman-meeting-request`,
    { meetingRequestId, approvedByUid, expectedMeetingDate, location }
  );
  return response.data;
};

export const rejectChairmanMeetingRequest = async ({
  meetingRequestId,
  rejectedByUid,
  rejectedReason,
}) => {
  const response = await axios.post(
    `${apiUrl}/reject-chairman-meeting-request`,
    { meetingRequestId, rejectedByUid, rejectedReason }
  );
  return response.data;
};

export const markChairmanMeetingCreated = async ({
  meetingRequestId,
  personUserUid,
  personName,
}) => {
  const response = await axios.post(
    `${apiUrl}/update-chairman-meeting-created`,
    { meetingRequestId, personUserUid, personName }
  );
  return response.data;
};
